import { Footer2 ,TopBanner,AboutDetail} from "../../components";
const AboutUs = ({props}) =>{
    return(
        <>
      
      <TopBanner>
       درباره ما
        </TopBanner>
<AboutDetail/>    
      
        </>
    )
}
export default AboutUs;